import React from 'react'

import './style.css'

const content1 = require('./graph1.jpg')

export default class DashboardSolo extends React.Component {

  render() {
    return ( /* eslint-disable max-len */
      <div className="isoLayoutContentWrapper solo-dashboard">

        <div className="ant-col-xs-24 ant-col-sm-24 ant-col-md-24" style={{paddingLeft: 8, paddingRight: 8, marginBottom: 16}}>
          <div className="isoBoxWrapper sc-chPdSV cOTLJI">
            <div>
              <h3 className="isoBoxTitle sc-cSHVUG ifvfLf"> INFO </h3>
              <p className="isoBoxSubTitle sc-kAzzGY gCwUWQ">
                Veškeré zobrazitelné informace k jednotlivým balíčkům jsou vidět na stránce <b>Dashboard</b> v sekcích <b>My Workers</b> nahoře a dole v sekci <b>Raw data / Purchase</b>.
              </p>
            </div>
          </div>
        </div>

        <h1 className="isoComponentTitle sc-jzJRlG kviPuT">Overview</h1>

        <div className="container-fluid">
          {/* Row */}
          <div className="row">
            <div className="col-lg-3 col-md-6 col-sm-6 col-xs-12">
              <div className="panel panel-default card-view pa-0 bg-gradient">
                <div className="panel-wrapper collapse in">
                  <div className="panel-body pa-0">
                    <div className="sm-data-box">
                      <div className="container-fluid">
                        <div className="row">
                          <div className="col-xs-6 text-center pl-0 pr-0 data-wrap-left">
                            <span className="txt-light block counter"><span className="counter-anim">200 MH/s</span></span>
                            <span className="weight-500 uppercase-font block font-13 txt-light">Total Hashrate</span>
                          </div>
                          <div className="col-xs-6 text-center  pl-0 pr-0 data-wrap-right">
                            <i className="icon-direction data-right-rep-icon txt-light" />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-md-6 col-sm-6 col-xs-12">
              <div className="panel panel-default card-view pa-0 bg-gradient1">
                <div className="panel-wrapper collapse in">
                  <div className="panel-body pa-0">
                    <div className="sm-data-box">
                      <div className="container-fluid">
                        <div className="row">
                          <div className="col-xs-6 text-center pl-0 pr-0 data-wrap-left">
                            <span className="txt-light block counter"><span className="counter-anim">15.00</span>%</span>
                            <span className="weight-500 uppercase-font block txt-light">PROFIT</span>
                          </div>
                          <div className="col-xs-6 text-center  pl-0 pr-0 data-wrap-right">
                            <i className="icon-graph  data-right-rep-icon txt-light" />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-md-6 col-sm-6 col-xs-12">
              <div className="panel panel-default card-view pa-0 bg-gradient3">
                <div className="panel-wrapper collapse in">
                  <div className="panel-body pa-0">
                    <div className="sm-data-box">
                      <div className="container-fluid">
                        <div className="row">
                          <div className="col-xs-6 text-center pl-0 pr-0 data-wrap-left">
                            <span className="txt-light block counter"><span className="counter-anim">2.5</span>ETH</span>
                            <span className="weight-500 uppercase-font block txt-light">YIELD</span>
                          </div>
                          <div className="col-xs-6 text-center  pl-0 pr-0 data-wrap-right">
                            <i className="icon-layers data-right-rep-icon txt-light" />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-md-6 col-sm-6 col-xs-12">
              <div className="panel panel-default card-view pa-0 bg-gradient2">
                <div className="panel-wrapper collapse in">
                  <div className="panel-body pa-0">
                    <div className="sm-data-box">
                      <div className="container-fluid">
                        <div className="row">
                          <div className="col-xs-6 text-center pl-0 pr-0 data-wrap-left">
                            <span className="txt-light block counter"><span className="counter-anim">1.8</span>ETH</span>
                            <span className="weight-500 uppercase-font block txt-light">Balance</span>
                          </div>
                          <div className="col-xs-6 text-center  pl-0 pr-0 data-wrap-right">
                            <i className="icon-flag  data-right-rep-icon txt-light" />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* /Row */}
          {/* Row */}
          <div className="row">
            <div className="col-lg-4 col-md-6 col-sm-12 col-xs-12">
              <div className="panel card-view">
                <div className="panel-heading small-panel-heading relative">
                  <div className="pull-left">
                    <h6 className="panel-title">Category Overview</h6>
                  </div>
                  <div className="clearfix" />
                </div>
                <div className="panel-wrapper collapse in">
                  <div className="panel-body row pa-0">
                    <div className="sm-data-box">
                      <div className="container-fluid">
                        <div className="row">
                          <div className="col-xs-6 text-center pl-0 pr-0 data-wrap-left">
                            <span className="block"><i className="zmdi zmdi-trending-up txt-success font-18 mr-5" /><span className="weight-500 uppercase-font">growth</span></span>
                            <span className="txt-dark block counter">$<span className="counter-anim">5,676</span></span>
                          </div>
                          <div className="col-xs-6 text-center  pl-0 pr-0 data-wrap-right">
                            <div id="sparkline_7" className="sp-small-chart"><canvas width={100} height={100} style={{display: 'inline-block', width: 100, height: 100, verticalAlign: 'top'}} /></div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="panel card-view bg-gradient2">
                <div className="panel-heading small-panel-heading relative">
                  <div className="pull-left">
                    <h6 className="panel-title txt-light">Monthly Revenue</h6>
                  </div>
                  <div className="clearfix" />
                </div>
                <div className="panel-wrapper collapse in">
                  <div className="panel-body row pa-0">
                    <div className="sm-data-box">
                      <div className="container-fluid">
                        <div className="row">
                          <div className="col-xs-6 text-center pl-0 pr-0 data-wrap-left txt-light">
                            <span className="block"><i className="zmdi zmdi-trending-up txt-light font-18 mr-5" /><span className="weight-500 uppercase-font">growth</span></span>
                            <span className="block counter">$<span className="counter-anim">15,678</span></span>
                          </div>
                          <div className="col-xs-6 text-center  pl-0 pr-0 data-wrap-right">
                            <div id="sparkline_6" className="sp-small-chart"><canvas width={100} height={124} style={{display: 'inline-block', width: 100, height: 124, verticalAlign: 'top'}} /></div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-8 col-md-6 col-sm-12 col-xs-12">
              <div className="panel panel-default card-view panel-refresh">
                <div className="panel-heading">
                  <div className="pull-left">
                    <h6 className="panel-title txt-dark">Yield graph</h6>
                  </div>
                </div>
                <div className="panel-wrapper collapse in">
                  <img src={content1} width={620} height={374}/>
                </div>
              </div>
            </div>
          </div>
          {/* /Row */}
        </div>

        <h1 className="isoComponentTitle sc-jzJRlG kviPuT">Workers</h1>

        <Worker mhs={40} days={326}/>
        <Worker mhs={80} days={511}/>
        <Worker mhs={120} days={640}/>

      </div>
    )
  }
}


const Worker = ({mhs, days}) => (


  <div className="container-fluid">
  {/* Row */}
  <div className="row">
    <div className="col-lg-3 col-md-6 col-sm-6 col-xs-12">
      <div className="">
        <div className="panel-wrapper collapse in">
          <div className="panel-body pa-0">
            <div className="sm-data-box">
              <div className="container-fluid">
                <div className="row">
                  <label><input
                    type="checkbox" className="switch"
                    defaultChecked={!!Math.round(Math.random())}
                  />[SHOW IN GRAPH OVERVIEW]</label>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div className="col-lg-3 col-md-6 col-sm-6 col-xs-12">
      <div className="panel panel-default card-view pa-0 bg-gradient">
        <div className="panel-wrapper collapse in">
          <div className="panel-body pa-0">
            <div className="sm-data-box">
              <div className="container-fluid">
                <div className="row">
                  <div className="col-xs-6 text-center pl-0 pr-0 data-wrap-left">
                    <span className="txt-light block counter"><span className="counter-anim">{mhs}</span>MH/s</span>
                    <span className="weight-500 uppercase-font block font-13 txt-light">Hashrate</span>
                  </div>
                  <div className="col-xs-6 text-center  pl-0 pr-0 data-wrap-right">
                    <i className="icon-direction data-right-rep-icon txt-light" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div className="col-lg-3 col-md-6 col-sm-6 col-xs-12">
      <div className="panel panel-default card-view pa-0 bg-gradient2">
        <div className="panel-wrapper collapse in">
          <div className="panel-body pa-0">
            <div className="sm-data-box">
              <div className="container-fluid">
                <div className="row">
                  <div className="col-xs-6 text-center pl-0 pr-0 data-wrap-left">
                    <span className="txt-light block counter"><span className="counter-anim">{days}</span>days</span>
                    <span className="weight-500 uppercase-font block txt-light">Expiration</span>
                  </div>
                  <div className="col-xs-6 text-center  pl-0 pr-0 data-wrap-right">
                    <i className="icon-flag  data-right-rep-icon txt-light" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  {/* /Row */}
</div>
)



// WEBPACK FOOTER //
// ./src/pages/DashboardMulti/index.tsx